import { Trash2, Crop, ArrowRightLeft } from 'lucide-react'
import { Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip'
import Scissors from '@/components/common/icons/Scissors'
import PickThumbnail from '@/components/common/icons/PickThumbnail'

const ActionButtons = ({
    asset,
    handleDeleteCard,
    goToMediaLibrary,
    gotToCropPage,
    gotToVideoTrim,
    openThumbnailEditor,
}) => {
    const isVideo = () => asset.mime_type.startsWith('video')

    return (
        <div className="tw:flex tw:items-center tw:gap-4">
            {isVideo(asset) && (
                <>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <button
                                className="tw:p-1 tw:bg-transparent tw:border-0 tw:text-blue-300 hover:tw:text-blue-200"
                                onClick={(e) => {
                                    e.stopPropagation()
                                    gotToVideoTrim()
                                }}
                            >
                                <Scissors size={16} className="tw:text-blue-300 hover:tw:text-blue-200" />
                            </button>
                        </TooltipTrigger>
                        <TooltipContent>Trim video</TooltipContent>
                    </Tooltip>

                    <Tooltip>
                        <TooltipTrigger asChild>
                            <button
                                className="tw:p-1 tw:bg-transparent tw:border-0 tw:text-blue-300 hover:tw:text-blue-200"
                                onClick={(e) => {
                                    e.stopPropagation()
                                    openThumbnailEditor()
                                }}
                            >
                                <PickThumbnail className="tw:w-4 tw:h-4" />
                            </button>
                        </TooltipTrigger>
                        <TooltipContent>Edit video thumbnail</TooltipContent>
                    </Tooltip>
                </>
            )}
            <Tooltip>
                <TooltipTrigger asChild>
                    <button
                        className="tw:p-1 tw:bg-transparent tw:border-0 tw:text-blue-300 hover:tw:text-blue-200"
                        onClick={(e) => {
                            e.stopPropagation()
                            gotToCropPage()
                        }}
                    >
                        <Crop size={16} />
                    </button>
                </TooltipTrigger>
                <TooltipContent>Crop {isVideo(asset) ? 'video' : 'image'}</TooltipContent>
            </Tooltip>
            <Tooltip>
                <TooltipTrigger asChild>
                    <button
                        className="tw:p-1 tw:bg-transparent tw:border-0 tw:text-blue-300 hover:tw:text-blue-200"
                        onClick={(e) => {
                            e.stopPropagation()
                            goToMediaLibrary()
                        }}
                    >
                        <ArrowRightLeft size={16} />
                    </button>
                </TooltipTrigger>
                <TooltipContent>Replace {isVideo(asset) ? 'video' : 'image'}</TooltipContent>
            </Tooltip>
            <Tooltip>
                <TooltipTrigger asChild>
                    <button
                        className="tw:p-1 tw:bg-transparent tw:border-0 tw:text-blue-300 hover:tw:text-blue-200"
                        onClick={(e) => {
                            e.stopPropagation()
                            handleDeleteCard(asset.id)
                        }}
                    >
                        <Trash2 size={16} />
                    </button>
                </TooltipTrigger>
                <TooltipContent>Delete</TooltipContent>
            </Tooltip>
        </div>
    )
}

export default ActionButtons
